import React from 'react';
import CourierRoutePage from './CourierRoutePage';
import { ROUTE_PAGES } from '../data/routePages';

const CourierToUKPage = () => <CourierRoutePage page={ROUTE_PAGES.uk} />;

export default CourierToUKPage;
